
import { get, groupBy, intersection } from 'lodash';
// 处理完整版国高入学测评 报告页数据
export const handleAnswer = data => {
  const { questions, subjects } = data;
  const questionBox = groupBy(questions, 'practiceId');
  let answers = [];
  // 获取科目下的习题
  for (let i = 0; i < subjects.length; i += 1) {
    const subjectPractices = subjects[i].practices;
    let currentQuestions = [];
    subjectPractices.forEach(subjectPractice => {
      currentQuestions = currentQuestions.concat(questionBox[subjectPractice.toFixed(0)]);
    })
    const currentAnswers = currentQuestions.map(question => {
      const answer = {
        answer: get(question, 'materials.0.answer'),
        userAnswer: get(question, 'materials.0.userAnswer.answer'),
      };
      return answer;
    });
    answers = answers.concat(currentAnswers);
  }
  const newAnswers = answers.map((item, index) => {
    item.index = index;
    item.score = [29].indexOf(index) > -1 ? 3 : 1;
    return item;
  })
  // 计算各科目正确率
  const countScore = (answers, isBlank = false) => {
    let correct = 0;
    const score = answers.reduce((total, item) => {
      const { answer, userAnswer, score } = item;
      if (isBlank) {
        answer.map((item1, index) => {
          if (userAnswer && item1.indexOf(userAnswer[index]) >= 0) correct += 1;
          return false;
        })
        return total + correct * 1 || 0;
      } else {
        correct += intersection(answer, userAnswer || []).length;
        return total + (intersection(answer, userAnswer || []).length) * score || 0;
      }
    }, 0)
    const count = answers.reduce((total, item) => {
      const { answer } = item;
      return total + answer.length;
    }, 0)
    return { score, count, correct }
  }
  // 处理结果
  const result = [
    { name: '单项选择', ...countScore(newAnswers.slice(0, 20)) },
    { name: '完形填空', ...countScore(newAnswers.slice(20, 21), true) },
    { name: '阅读理解', ...countScore(newAnswers.slice(21, 34)) },
    { name: '数学', ...countScore(newAnswers.slice(34, 60)) },
  ]
  return result;
}



// WEBPACK FOOTER //
// ./src/components/report/utils/handleSenior.js